/* eslint-disable */

//tslint:disable

import { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api/shared/http';
import {
  TGetPublishTermsInfoModel,
  IGetPublishTermsInfoRequest,
  IMappers,
  IGetPublishTermsInfoResponse,
  IGetPublishTermsInfoResponseError,
  TGetPublishTermsInfoResponse,
} from './types';

const defaultConfig: TGetPublishTermsInfoModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  method: 'GET',
  microserviceName: 'billing-tariffs',
  pathApi: '/v1/get-publish-terms-info/',
  hostType: 'api',
} as TGetPublishTermsInfoModel;

function createGetPublishTermsInfoModel(parameters: IGetPublishTermsInfoRequest): TGetPublishTermsInfoModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IGetPublishTermsInfoOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  parameters: IGetPublishTermsInfoRequest;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

async function fetchGetPublishTermsInfo<TResponse200, TResponse400>({
  httpApi,
  parameters,
  config,
  mappers,
}: IGetPublishTermsInfoOptions<TResponse200, TResponse400>): Promise<
  TResponse200 | TResponse400 | TGetPublishTermsInfoResponse
> {
  const { response, statusCode } = await httpApi.fetch(createGetPublishTermsInfoModel(parameters), config);

  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IGetPublishTermsInfoResponse);
    }

    if (statusCode === 400) {
      return mappers[400](response as IGetPublishTermsInfoResponseError);
    }
  }

  return { response, statusCode } as TGetPublishTermsInfoResponse;
}

export { defaultConfig, createGetPublishTermsInfoModel, fetchGetPublishTermsInfo };
